import axios from 'axios'
import { API_SEND_MAIL } from '../../enviroments/environments'

export default new class {

    /**
     * Send email contact
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    sendMail(data){
        return axios.post(API_SEND_MAIL, data);
    }
}
